<button
  type="button"
  class="flex items-center justify-center w-10 h-10 rounded-lg border-2 border-white bg-60 bg-center"
  [style.backgroundImage]="languageFlagUrl ? 'url(' + languageFlagUrl + ')' : ''"
></button>
